import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
  Link,
  Chip,
} from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  ActionIconButton,
} from '../../../../common/components';

const AllotmentsDataTable = ({
  data,
  isLoading,
  onEdit,
  onDelete,
  onViewPlan,
  LoadingComponent,
  canEditLots = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return (
      <GeneralTableBox>
        {isLoading ? (
          <LoadingComponent />
        ) : data && data.length > 0 ? (
          <Box sx={{ p: 2 }}>
            {data.map((allotment, index) => (
              <Box
                key={allotment.uuid || index}
                sx={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  p: 2,
                  mb: 2,
                  backgroundColor: 'white',
                }}
              >
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr', gap: 1, mb: 2 }}>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Nombre
                    </Typography>
                    <Typography variant="body2" fontWeight="medium">
                      {allotment.name}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Plano
                    </Typography>
                    {allotment.image_url ? (
                      <Link component="button" onClick={() => onViewPlan?.(allotment)}>
                        Ver plano
                      </Link>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        Sin plano
                      </Typography>
                    )}
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      Estado
                    </Typography>
                    <Chip
                      label={allotment.is_active ? 'Activo' : 'Inactivo'}
                      size="small"
                      color={allotment.is_active ? 'success' : 'default'}
                    />
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                  <ActionIconButton
                    variant="edit"
                    onClick={() => onEdit(allotment)}
                    disabled={!canEditLots}
                  />
                  <ActionIconButton
                    variant="delete"
                    onClick={() => onDelete(allotment)}
                    disabled={!canEditLots}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <NoDataSkeleton colSpan={1} message="No se encontraron loteos" />
        )}
      </GeneralTableBox>
    );
  }

  return (
    <GeneralTableBox>
      <Table aria-label="allotments table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="35%" wxs="40%">
              Nombre
            </HeadTableCell>
            <HeadTableCell wmd="35%" wxs="40%">
              Plano
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="10%">
              Estado
            </HeadTableCell>
            <HeadTableCell wmd="15%" wxs="10%">
              Acciones
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((allotment, index) => (
              <TableRow key={allotment.uuid || index}>
                <RowTableCell>{allotment.name}</RowTableCell>
                <RowTableCell>
                  {allotment.image_url ? (
                    <Link component="button" onClick={() => onViewPlan?.(allotment)}>
                      Ver plano
                    </Link>
                  ) : (
                    'Sin plano'
                  )}
                </RowTableCell>
                <RowTableCell>
                  <Chip
                    label={allotment.is_active ? 'Activo' : 'Inactivo'}
                    size="small"
                    color={allotment.is_active ? 'success' : 'default'}
                  />
                </RowTableCell>
                <RowTableCell sx={{ textAlign: 'center' }}>
                  <ActionIconButton
                    variant="edit"
                    onClick={() => onEdit(allotment)}
                    disabled={!canEditLots}
                  />
                  <ActionIconButton
                    variant="delete"
                    onClick={() => onDelete(allotment)}
                    disabled={!canEditLots}
                  />
                </RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={4} message="No se encontraron loteos" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default AllotmentsDataTable;
